import React from 'react';

import Button, { ButtonProps } from '@material-ui/core/Button';
import clsx from 'clsx';

import { useStyles } from './style';

interface Props extends ButtonProps {
  onClick: any;
  buttonStyle?: 'primary' | 'secondary' | 'icon' | 'blueButton' | 'blueTransparent' | 'white';
  isSmall?: boolean;
  width?: number | 'auto';
  bordered?: boolean;
}

export const CommonButton: React.FC<Props> = React.memo(
  ({ title, isSmall, width, buttonStyle = 'primary', bordered = false, ...btnProps }) => {
    const classes = useStyles({ width, bordered });
    return (
      <Button
        classes={{
          root: clsx([classes.root, classes[buttonStyle], isSmall && classes.smallButton]),
        }}
        {...btnProps}
      >
        {title}
      </Button>
    );
  },
);
